import { useCallback, useImperativeHandle, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'

import { QueryDropdown } from 'basic-components'
import { DropdownService } from 'primary-components'

import getApiConfig from 'api/ApiConfig'

import AccessContextMenu from '../AccessContextMenu'
import DataRange from './DataRange'
import SendMessage from './SendMessage'

import { useQueryClient } from '@tanstack/react-query'
import { When } from 'react-if'

import './SecondStep.scss'

const EMPTY_ARRAY = []
const SecondStep = ({ addUserSelected, menuPortalTarget = undefined, withDataRange = false, ref }) => {
  const dispatch = useDispatch(),
        [access, setAccess] = useState(() => addUserSelected?.length === 1 ? addUserSelected[0]?.access || "R" : "R"),
        [users, setUsers] = useState(addUserSelected),
        dataRangeRef = useRef(),
        sendMessageRef = useRef(),

        onUsersChange = useCallback((_, { data }) => setUsers(data), []),

        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        [emailQuery, setEmailQuery] = useState(),
        queryClient = useQueryClient(),
        { fetchNextPage: fetchMoreEmails, isFetching: isFetchingEmails, isFetchingNextPage: isFetchingNextPageEmails, data: emailsFromApi = EMPTY_ARRAY } = DropdownService.useQueryEmails({
          queryClient,
          input: emailQuery,
          getApiConfig: getApiConfigLocal
        })

  useImperativeHandle(ref, () => ({
    getUsers: () => users,
    getAccess: () => access,
    getDataStart: () => dataRangeRef.current.getDataStart(),
    getDataEnd: () => dataRangeRef.current.getDataEnd(),
    getTimezone: () => dataRangeRef.current.getTimezone(),
    shouldSendMessage: () => sendMessageRef.current.shouldSendMessage(),
    getMessage: () => sendMessageRef.current.getMessage()
  }))

  return (
    <div className="data-lake__group-dialog__edit-access">
      <div className="data-lake__group-dialog__edit-access__top">
        <div className="data-lake__group-dialog__edit-access__top__left">
          <QueryDropdown
              captureMenuScroll
              creatable
              defaultValue={users}
              dynamicHeight
              fetchNextPage={fetchMoreEmails}
              isFetching={isFetchingEmails || isFetchingNextPageEmails}
              menuPortalTarget={menuPortalTarget}
              multi
              name="newShareUsers"
              noError
              onChange={onUsersChange}
              onInputChange={setEmailQuery}
              options={emailsFromApi}
              placeholder="Add users"
              size="large"
              variant="border"
              withSelectAll
          />
        </div>
        <div className="data-lake__group-dialog__edit-access__top__right">
          <AccessContextMenu
              access={access}
              onAccessChange={setAccess}
          />
        </div>
      </div>
      <When condition={withDataRange}>
        {() => (
          <DataRange
              defaultDataEnd={addUserSelected?.length === 1 ? addUserSelected[0]?.dataEnd : undefined}
              defaultDataStart={addUserSelected?.length === 1 ? addUserSelected[0]?.dataStart : undefined}
              defaultTimezone={addUserSelected?.length === 1 ? addUserSelected[0]?.timeZone : undefined}
              ref={dataRangeRef}
              timezoneFixed
          />
        )}
      </When>
      <SendMessage
          ref={sendMessageRef}
      />
    </div>
  )
}
SecondStep.displayName = "SecondStep"

SecondStep.propTypes = {
  addUserSelected: PropTypes.array.isRequired,
  menuPortalTarget: PropTypes.object,
  withDataRange: PropTypes.bool
}

export default SecondStep
